import React, { useState, useEffect, useRef, useMemo } from "react";
import { Grid, TextField } from "@mui/material";
import InputTextSearch from "../../../reuseableComponents/InputTextSearch";
import SelectDropDown from "../../../reuseableComponents/SelectDropDown";
import { useSelector, useDispatch } from "react-redux";
import { useAuthDetails } from "../../../Common/cookiesHelper";
import PasswordShow from "../../../Common/passwordShow";
import {
  fetchStoresData,
  fetchPaylistData,
} from "../../../Redux/features/SingleStore/singleStoresSlice";
const MainOnline = ({
  setSelectedTransaction,
  selectedTransaction,
  setOrderSourceData,
  setOrderTypeData,
  setOnlSearchIdData,
  OnlSearchIdData,
  OrderTypeData,
}) => {
  const orderStatusList = [
    {
      title: "All",
    },
    {
      title: "New",
    },
    {
      title: "Completed",
    },
    {
      title: "Failed",
    },
  ];

  const dispatch = useDispatch();
  const { LoginGetDashBoardRecordJson, userTypeData } = useAuthDetails();

  const { handleCoockieExpire, getUnAutherisedTokenMessage, getNetworkError } =
    PasswordShow();

  const { storesData, loading } = useSelector((state) => state.singleStores);

  let merchant_id = LoginGetDashBoardRecordJson?.data?.merchant_id;

  useEffect(() => {
    getStoreData();
  }, [merchant_id]);
  const getStoreData = async () => {
    try {
      const Storedata = {
        merchant_id: merchant_id,
        ...userTypeData,
      };
      await dispatch(fetchStoresData(Storedata)).unwrap();
    } catch (error) {
      if (error?.status == 401) {
        getUnAutherisedTokenMessage();
        handleCoockieExpire();
      } else if (error?.status == "Network Error") {
        getNetworkError();
      }
    }
  };

  const transactionsList = useMemo(() => {
    const paymentModes = {
      0: [{ title: "Cash" }],
      1: [{ title: "Credit Card" }],
      2: [{ title: "Both" }, { title: "Cash" }, { title: "Credit Card" }],
    };
    return (
      paymentModes[storesData?.Paymentmode?.cc_payment] || [{ title: "Cash" }]
    );
  }, [storesData]);

  useEffect(() => {
    if (transactionsList.length > 0) {
      setSelectedTransaction(transactionsList[0].title);
      // setOrderSourceData(transactionsList[0].title)
    }
  }, [transactionsList]);

  const handleOptionClick = (option, dropdown) => {
    switch (dropdown) {
      case "transaction":
        setSelectedTransaction(option.title);
        setOrderSourceData(option.title);
        break;
      case "orderStatus":
        setOrderTypeData(option.title);
        break;
      default:
        break;
    }
  };

  return (
    <>
      <Grid container className="px-2 sm:px-5">
        <Grid item xs={12}>
          <Grid container className="mt-5">
            <Grid item xs={12} className="">
              <InputTextSearch
                // placeholder="Search orders by order ID, last 4 digits on payment card, Customer Name, Order Amount or invoice ID"
                placeholder="Search by Order ID, Card Last 4, Name, or Amount"
                value={OnlSearchIdData}
                handleChange={setOnlSearchIdData}
              />
            </Grid>
          </Grid>
          {!OnlSearchIdData && (
            <>
              <Grid container className="mt-5 ">
                <Grid item className="mt_card_header q_dashbaord_netsales ">
                  <h1 className="">Filter By</h1>
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                {storesData?.Paymentmode?.cc_payment === "2" && (
                  <Grid item xs={12} sm={6} md={4}>
                    <label htmlFor="transactionFilter">Payment Type</label>
                    <SelectDropDown
                      sx={{ pt: 0.5 }}
                      listItem={transactionsList}
                      title={"title"}
                      onClickHandler={handleOptionClick}
                      selectedOption={selectedTransaction}
                      dropdownFor={"transaction"}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={6} md={4}>
                  <label htmlFor="orderStatusFilter">Order Status</label>
                  <SelectDropDown
                    sx={{ pt: 0.5 }}
                    heading={""}
                    listItem={orderStatusList}
                    title={"title"}
                    onClickHandler={handleOptionClick}
                    selectedOption={OrderTypeData}
                    dropdownFor={"orderStatus"}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default MainOnline;
